"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("../section/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:fieldset": ["sections"],
  "sections": {
    "ui:layout": "section",
    "ui:title": "Innhold",
    "ui:preview": {
      "select": {
        "description": "description"
      },

      prepare({
        formData = []
      }) {
        let description;

        if (formData.length && formData.length === 1) {
          description = formData.length + " seksjon";
        } else if (formData.length) {
          description = formData.length + " seksjoner";
        } else {
          description = "Ingen seksjoner";
        }

        return {
          "description": description
        };
      }

    },
    "ui:options": {
      "collapsible": true,
      "expanded": true,
      "draggable": true,
      "padding": 2
    },
    "ui:buttons": [{
      "label": "Tekst",
      "item": {
        "sectionType": "text"
      }
    }, {
      "label": "Media",
      "item": {
        "sectionType": "media"
      }
    }, {
      "label": "Ekultur",
      "item": {
        "sectionType": "ekultur"
      }
    }],
    "items": _uiSchema.default
  }
};
exports.default = _default;
module.exports = exports.default;